import React from 'react'
import Animal from '../animals/Animal'

export default function AnimalPackage(props) {
    return <Animal {...props} packageMode />
}
